<template>

    <vx-card class="px-4 ">
        <!-- MAIL HEAD -->
        <div >
            <div class="vx-row">
                <div
                    class="vx-col w-full flex justify-between mb-4" >
                    <vs-chip color="warning" class="ml-2">
                        <span>{{ $t('credit') }}: {{ discipline.credit }}</span>
                    </vs-chip>
                    <Counter/>
                </div>
                <div
                    v-if="!itocline"
                    class=" w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
                    <!-- Sender Details -->

                    <div class="flex items-center">
                        <div class="flex flex-col">
                            <h5 class="mb-1 type">{{ $t('load_type') }}</h5>
                        </div>
                    </div>
                    <!-- /Sender Details -->
                </div>
                <!-- /Mail Time & Date -->
            </div>

            <!-- MAIL CONTENT -->
            <div class="vx-row " v-if="!itocline">
                <div class="vx-col w-full">

                    <div class="mail__content break-words mt-8 mb-4" v-if="discipline.type_load.length">


                        <div class="vx-row mt-8 mb-4" v-for="(load,i) in discipline.type_load" :key="'load_'+load.uid">
                            <!--                            <div class="flex w-full justify-between items-start">-->
                            <vs-col vs-lg="6" vs-xs="12" :class="{'items-center':load.training_format.name == ''?true:false,'flex':load.training_format.name == ''?true:false}">
                                <h6 class="mb-1">{{ load.name }}</h6>
                                <span style="font-size: 12px;">{{ load.training_format.name }}</span>
                            </vs-col>

                            <vs-col vs-lg="6" vs-xs="12" vs-align="center" class="">
                                <!--                                    <div class="w-full flex justify-around">-->
                                <!--                                    <div class="vx-row">-->
                                <vs-col vs-lg="5" vs-xs="12" class="mt-1">
                                    <multiselect
                                        v-model="select['lang'][i]"
                                        :options="language_options"
                                        @open="selectLanguageNew(load.uid,i)"
                                        :disabled="DisabledLang||load.uid_1c=='СРС'"
                                        :loading="loading_language"
                                        tag-position="top"
                                        placeholder="Язык"
                                        v-validate="'required'"
                                        open-direction="top"
                                        @input="changeMultiSelect(i,load.uid_1c)"
                                        label="language_name"
                                        name="lang"
                                        style="width: 90%;"
                                        track-by="uid"
                                        :max-height="81"
                                        selectedLabel=""
                                        selectGroupLabel=""
                                        selectLabel=""
                                        deselectLabel="">
                                        <div slot="noOptions">{{ $t('no_data_text') }}</div>
                                    </multiselect>
                                </vs-col>
                                <vs-col vs-lg="7" vs-xs="12" class="mt-1">
                                    <multiselect
                                        v-model="select['teacher'][i]"
                                        :options="teacher_options"
                                        @open="selectTeacherNew(load.uid,i)"
                                        :disabled="DisabledTeacher(i)||DisabledLang||load.uid_1c=='СРС'"
                                        placeholder="Преподаватель"
                                        v-validate="'required'"
                                        open-direction="top"
                                        :loading="loading_teacher"
                                        style="width: 90%;"
                                        label="teacher_name"
                                        :max-height="81"
                                        name="teacher"
                                        @input="changeTeacherMultiSelect(i,load.uid_1c)"
                                        tag-position="top"
                                        track-by="teacher"
                                        selectedLabel=""
                                        selectGroupLabel=""
                                        selectLabel=""
                                        deselectLabel="">
                                        <div slot="noOptions">{{ $t('no_data_text') }}</div>
                                    </multiselect>
                                </vs-col>
                                <!--                                    </div>-->
                                <!--                                    </div>-->
                            </vs-col>
                            <!--                            </div>-->
                        </div>

                    </div>
                </div>
            </div>
            <div v-if="itocline">
                <ControlForms
                    :data="controlFormsData"
                    :isCheck="isCheck"
                    :DisabledLang="DisabledLang"
                    :status="discipline.status"
                    v-on:SendDiscepline="SendDiscepline"
                    v-on:СancelDiscepline="СancelDiscepline()"/>
            </div>

            <!-- MAIL ATTACHMENTS -->
            <div class="vx-row" v-if="discipline&&!itocline" >
                <div class="flex">
                    <div class="mail__attachment">
                        <vs-button
                            :color="isCheck.color"
                            class="px-4 py-2 mr-3 cursor-pointer"
                            :disabled="isCheck.disabled||DisabledLang"
                            @click="SendDiscepline()">
                            {{ isCheck.text }}
                        </vs-button>
                        <vs-button
                            v-if="isCheck.cancel_text"
                            color="primary"
                            class="px-4 py-2 mr-3 cursor-pointer"
                            :disabled="isCheck.disabled||DisabledLang"
                            @click="СancelDiscepline()">
                            {{ isCheck.cancel_text }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </div>

    </vx-card>

</template>

<script>
import Counter from '../Counter.vue'
import SelectMixin from './SelectMixin.vue'
import {mapMutations, mapGetters} from 'vuex'
import CounterMixin from '../DisList/CounterMixin.vue'
import CycleMixin from '../DisList/CycleMixin.vue';
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import changeStatusMixin from '../DisList/changeStatusMixin.vue'
import ControlForms from "../ControlFromsView.vue";
export default {
    components: {Counter,ControlForms},
    mixins: [SelectMixin, CounterMixin, CycleMixin, VuePerfectScrollbar, changeStatusMixin],
    props: {
        discipline: {
            type: Object,
        }
    },

    computed: {
        is_edvisor() {
            return this.$store.state.user.user.role.is_supervisor
        },
        ...mapGetters({
            getCreditLimitSystem:"regis_discepline/getCreditLimitSystem",
            limit: 'regis_discepline/limitDiscepline',
            disceplines: 'regis_discepline/getListDiscepline',
            itocline: 'regis_discepline/getitocline',
            obj: "ApplicationForISC/application"
        }),
        // data(){
        //     if (this.controlFormsData[0].disciplines){
        //         return this.controlFormsData[0].disciplines
        //     }
        //
        // },
        isCheck() {
            var result = {}
            if (this.discipline.status.utverzhden)
                result = {
                    text: this.$t('APPROVED'),
                    color: 'success',
                    disabled: true,
                    status: 'utverzhden',
                };
            else if (this.discipline.status.nevybran)
                result = {
                    text: this.$t('save'),
                    color: 'primary',
                    disabled: false,
                    status: 'nevybran',

                };
            else if (this.discipline.status.otklonen)
                result = {
                    text: this.$t('save_changes'),
                    color: 'danger',
                    cancel_text: this.$t('save_chang'),
                    disabled: false,
                    status: 'otklonen',

                };
            else if (this.discipline.status.izmenen)
                result = {
                    text: this.$t('save_changes'),
                    color: 'warning',
                    cancel_text: this.$t('save_chang'),
                    disabled: false,
                    status: 'izmenen',

                };
            else if (this.discipline.status.vybran)
                result = {
                    text: this.$t('save_changes'),
                    cancel_text: this.$t('save_chang'),
                    color: 'warning',
                    disabled: false,
                    status: 'vybran',

                };
            else if (this.discipline.status.vputi)
                result = {
                    text: this.$t('save_changes'),
                    color: 'warning',
                    cancel_text: this.$t('save_chang'),
                    disabled: false,
                    status: 'vputi',

                };
            else
                result = {
                    text: this.$t('save'),
                    color: 'primary',
                    disabled: false,
                    status: 'bezstatusa',

                }

            return result;
        },

    },
    data() {
        return {
            language_options: [],
            teacher_options: [],

            select: {
                lang: [],
                teacher: [],
            },
            controlFormsData:[],
            loading_language:false,
            loading_teacher:false,
        }
    },

    mounted() {
        this.generateSelected()

    },
    watch:{
        // itocline(){
        //     console.log(this.itocline)
        // }
    },
    async created() {
        await this.itocGet()
    },
    methods: {
        changeMultiSelect(i,uid_1c){
            this.select.teacher[i] = null
            if (uid_1c == 'СРСП'){
                this.discipline.type_load.forEach((item,index)=>{
                    if (item.uid_1c=='СРС'){
                        this.select.lang[index] = this.select.lang[i]
                        this.select.teacher[index] = null
                    }
                })
            }
        },
        changeTeacherMultiSelect(i,uid_1c){
            if (uid_1c == 'СРСП'){
                this.discipline.type_load.forEach((item,index)=>{
                    if (item.uid_1c=='СРС'){
                        this.select.teacher[index] = this.select.teacher[i]
                    }
                })
            }
        },
        async itocGet(){
            if (this.itocline){
                try {
                    var obj = []
                    var route = this.$route.query
                    await this.$http
                        .get("user/my_discipline/control_forms/", {
                            params: {
                                study_year: route.study_year,
                                study_plan: route.study_plan,

                                // ...(this.selectPeriud !== this.uidAllPeriods && {
                                //     acad_period: this.selectPeriud,
                                // }),
                                //
                                // ...(this.selectPeriud === this.uidAllPeriods && {
                                //     reg_period: this.DA.reg_period,
                                // }),
                            },
                        })
                        .then((response) => {
                            obj = response.data
                        });

                    this.controlFormsData = obj[0].disciplines;
                    // console.log(this.controlFormsData)
                    // console.log(this.controlFormsData[0].disciplines[0])
                } catch (e) {}
            }
        },
        СancelDiscepline() {
            var generateData = [];
            var acad_period = this.$route.query.acad_period
            var discipline = this.discipline.discipline.uid
            this.discipline.type_load.forEach(function (type, index) {
                generateData.push(
                    type.student_discipline_uid
                )
            });
            this.СancelPost(generateData)
        },
        async СancelPost(generateData) {
            try {
                var params = {}
                // if (this.is_edvisor) {
                //     var student = this.$route.query.student
                //     params = {
                //         student: student
                //     }
                // } else {
                //     params = {}
                // }
                this.$vs.loading();
                await this.$http.post(`user/cancel_discipline_student/`, generateData)
                    .then(async res => {
                        await this.getMaxAndMin();
                        this.CardchangeStatusDiscipline(res.data)
                        this.$vs.notify({
                            title: this.$t('succesful'),
                            color: "success"
                        })

                    })
                    .catch(e => {
                        console.error(e);
                    });
            } catch (e) {
                console.log(e)
            } finally {
                this.$vs.loading.close()
            }
        },
        ...mapMutations({
            setExceeding: 'regis_discepline/SET_EXCEED',// установка повышение лимита
            // changeStatus:'regis_discepline/CHANGE_STATUS_DISCIPLNE'
        }),

        reloadPageAdvaizer() {
            this.$router.push({name: 'applications_review_in_isc'})
        },
        async request_backend(item){
            if (this.itocline){
                await this.$http.put(
                    `user/control_forms/${ item.discipline_credit }/choose/`,
                    { chosen_control_forms: item.chosen_control_forms }
                );
            }
        },
        async SendDiscepline(val) {
            await this.getMaxAndMin()
            var calculate = this.limit.current + this.discipline.credit
            if ((this.limit.max >= calculate)||this.discipline.status.izmenen||this.discipline.status.vybran||this.discipline.status.vputi||!this.getCreditLimitSystem[0].credit_limit_system) {
                this.setExceeding(false);
                var type_load = this.discipline.type_load.length;
                var teacher = this.select.teacher;
                var language = this.select.lang;
                var acad_period = this.$route.query.acad_period
                var generateData = [];
                let teacher_list = []
                teacher.forEach((i)=>{
                    if(i != null){
                        teacher_list.push(i)
                    }
                })
                if ((!this.isCheck.disabled && type_load && teacher_list.length && language.length && type_load == teacher_list.length && type_load == language.length)||this.itocline) {
                    if (this.itocline){
                        this.discipline.type_load.forEach(function (type, index) {
                            generateData.push({
                                student_discipline_uid:type.student_discipline_uid,
                                teacher: null,
                                language: null,
                            })
                        });
                    }else{
                        this.discipline.type_load.forEach(function (type, index) {
                            generateData.push({
                                student_discipline_uid:type.student_discipline_uid,
                                teacher: teacher[index]['teacher'],
                                language: language[index]['uid'],
                            })
                        });
                    }
                    this.sendPost(acad_period, generateData,val)
                } else {
                    this.$vs.notify({
                        title: this.$t('choose_language_teacher_workloads'),
                        color: "warning"
                    })
                }
            } else {
                this.$vs.notify({
                    text: this.$t('exceeded_scored_credits'),
                    color: 'warning'
                })
                this.setExceeding(true);
            }
        },


        async sendPost(period, send_params,val) {
            try {
                this.$vs.loading();
                await this.$http.post(`user/put_discipline_student/`, send_params, {
                    params: this.$route.query
                })
                    .then(async res => {
                        this.request_backend(val)
                        this.CardchangeStatusDiscipline(res.data.data2)
                        this.changeTeacherLanguage(res.data.type_load)
                        await this.getMaxAndMin();
                        // this.status_data = res.data
                        this.$vs.notify({
                            title: this.$t('succesful'),
                            color: "success"
                        })
                    })
                    .catch(e => {
                        console.error(e);
                    });
            } catch (e) {
                console.log(e)
            } finally {
                this.$vs.loading.close()
            }
        },

        generateSelected() {
            if (this.discipline.type_load.length > 0) {

                this.discipline.type_load.forEach(async (type, i) => {

                    if (type.lang.language_uid && type.teacher.teacher_uid) {
                        this.select.lang[i] = {
                            uid: type.lang.language_uid,
                            language_name: type.lang.language_name,
                        }

                        this.select.teacher[i] = {
                            teacher: type.teacher.teacher_uid,
                            teacher_name: type.teacher.teacher_name,
                        }

                        await this.selectLanguage(type.uid,i,this.discipline.group_language,this.discipline.status,type.uid_1c);
                    }else{
                        await this.selectLanguage(type.uid,i,this.discipline.group_language,this.discipline.status,type.uid_1c);
                    }

                });

            }

        },


    },

}

</script>
<style lang="scss">
@media (max-width: 540px) {
    .type {
        display: none;
    }
}
.multiselect--active{
    z-index: 10000000000000000000000000;
}
.disNone{
    display: none;
}
</style>
